import fetch from 'utils/fetch'

// 获取登记接种列表
export function getRegisterList(params) {
    return fetch({
        method: 'GET',
        url: '/reservation/appReservation/home/appointments',
        params
    })
}
//
export function getVaccinateProcessOn(params,other) {
    return fetch({
        method: 'GET',
        url: '/reservation/vaccinate/processOn',
        params,
        ...other
    })
}
// 签到
export function getCheckIn(data) {
    return fetch({
        method: 'POST',
        url: '/reservation/vaccinate/checkIn',
        data
    })
}
/**
 * 获取/刷新接种流程信息
 * YAPI: https://doc.jsxygkj.com/project/257/interface/api/6935
 * 备注:
 */
export function checkVaccinateProcess(params,other = {}) {
    return fetch({
        url: '/reservation/vaccinate/process',
        method: 'GET',
        params,
        ...other
    })
}
/**
 * 获取档案二维码
 * YAPI: https://doc.jsxygkj.com/project/257/interface/api/6879
 * 备注:
 */
export function getAppProfileQrcodeProfileCode(profileCode, params, other = {}) {
    return fetch({
        url: `/reservation/appProfile/qrcode/${profileCode}`,
        method: 'GET',
        params,
        ...other
    })
}
// 获取自检问题列表
export function getAppQuestonList(params) {
    return fetch({
        url: '/reservation/vaccinate/preInspectionTpl',
        method: 'GET',
        params
    })
}
// 保存自检信息
export function saveAppInspection(data) {
    return fetch({
        url: '/reservation/vaccinate/saveInspection',
        method: 'POST',
        data
    })
}
/**
 * 获取告知书列表
 * YAPI: https://doc.jsxygkj.com/project/257/interface/api/6914
 * 备注:
 */
export function getAppDisclosureList(params, other = {}) {
    return fetch({
        url: `/reservation/vaccinate/disclosureList`,
        method: 'GET',
        params,
        ...other
    })
}
/**
 * 获取告知书详情
 * YAPI: https://doc.jsxygkj.com/project/257/interface/api/6893
 * 备注:
 */
export function getMaDisclosure(code, params, other = {}) {
    return fetch({
        url: `/master/maDisclosure/code/${code}`,
        method: 'GET',
        params,
        ...other
    })
}
/**
 * 获取告知书签字图片上传地址
 * YAPI: https://doc.jsxygkj.com/project/257/interface/api/6928
 * 备注:
 */
export function getVaccinateSignDisclosurePath(params, other = {}) {
    return fetch({
        url: `/reservation/vaccinate/signDisclosurePath`,
        method: 'GET',
        params,
        ...other
    })
}
/**
 * 保存告知书签字数据
 * YAPI: https://doc.jsxygkj.com/project/257/interface/api/6921
 * 备注:
 */
export function postVaccinateSaveDisclosureSign(data, other = {}) {
    return fetch({
        url: `/reservation/vaccinate/saveDisclosureSign`,
        method: 'POST',
        data,
        ...other
    })
}
/**
 * 获取登记人员列表
 * 备注:
 */
export function getRegisterFamily(data, other = {}) {
    return fetch({
        url: `/reservation/appUser/register/familyMember`,
        method: 'GET',
        data,
        ...other
    })
}
/**
 * 获取签到状态
 * 备注:
 */
export function getCheckInStatus(data, other = {}) {
    return fetch({
        url: `/reservation/vaccinate/getCheckInStatus`,
        method: 'POST',
        data,
        ...other
    })
}

